import React, { useState } from 'react';
import styled from 'styled-components';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import DefaultTable from './DefaultTable';
import axios from 'axios';
import { API_HOST } from '../../consts';
import { CSVLink } from 'react-csv';
import InsufficientData from '../../components/InsufficientData';
// import GetAppIcon from '@material-ui/icons/GetApp';
import { IconButton, Button } from '@material-ui/core';
import Loading from '../../components/Loading';

const DivLoading = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  align-items: center;
`;

const ComplexBarChart = ({
  tipo,
  etapa,
  turma,
  dre,
  ano,
  escola,
  disciplina,
  tituloCompleto,
  minWidthScroll,
  resume,
  externalData,
  externalTable,
  shoudFetch = true,
}) => {
  const [dados, setDados] = useState(externalData && externalData);
  const [table, setTable] = useState(externalTable && externalTable);
  const [fetched, setFetched] = useState(false);
  const fetchData = () => {
    const params = {
      tipo: tipo,
      etapa: etapa,
      turma: turma,
      dre: dre,
      ano: ano,
      escola: escola,
      disciplina: disciplina
    };
    axios
      .get(`${API_HOST}/avalia/estudante/get_notas_to_chart`, { params })
      .then((response) => {
        setDados(response.data.data.slice(0, -1));
        setTable(response.data.data.slice(-1)[0]['data_label']);
        setFetched(true);
      })
      .catch((err) => {
        setFetched(true);
      });
  };
  const mapped =
    dados &&
    dados.reduce((r, a) => {
      r[a.name] = [...(r[a.name] || []), a];
      r[a.data] = [...(r[a.data] || []), a];
      return r;
    }, {});

  const series = dados && Array.isArray(dados) ? dados.slice(0, -1) : [];

  if (!fetched && shoudFetch) {
    fetchData();
  }
  const min = window.location.host.includes('sesi') ? 100 : 0;
  var options = {
    chart: {
      type: 'column',
      scrollablePlotArea: {
        minWidth: minWidthScroll ? minWidthScroll : 0
      }
    },
    title: {
      text: tituloCompleto ? `${tituloCompleto && tituloCompleto}` : ''
    },
    xAxis: {
      type: 'category',
      labels: {
        rotation: 0,
        overflow: 'justify',
        style: {
          fontSize: '13px',
          fontFamily: 'Verdana, sans-serif'
        }
      }
    },
    yAxis: {
      min: min,
      title: {
        text: ''
      }
    },
    legend: {
      enabled: true
    },
    tooltip: {
      formatter: function () {
        return (
          '<b>' +
          this.series.name +
          ': ' +
          this.point.name +
          '</b><br/>' +
          this.series.name +
          ': ' +
          Highcharts.numberFormat(this.y, 2).replace('.', ',')
        );
      }
    },
    series: series
  };
  
  const table5 = ano && ano == 3 ? 'ENEM Oficial' : ' ';
  const dadosCSV =
    table &&
    table.map((dado) => {
      return {
        'Área do conhecimento': dado.name,
        // 'Menor Nota': dado.minimo && dado.minimo.toFixed(2),
        // Mediana: dado.mediana && dado.mediana.toFixed(2),
        Média: dado.data[0][1] && dado.data[0][1].toFixed(2).replace('.', ','),
        'Maior Proficiência': dado.maximo && dado.maximo.toFixed(2).replace('.', ','),
        'Desvio Padrão': dado.desvio && dado.desvio.toFixed(2).replace('.', ',')
      };
    });

  return (!fetched && !dados) ? (
    <DivLoading>
      <Loading />
    </DivLoading>
  ) : dados !== undefined ? (
    <div
      style={{
        width: '97.5%',
        minHeight: tipo && !tipo.includes('tct') ? '800px' : '300px',
        borderRadius: '8px',
        padding: '1rem',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      {tipo && !tipo.includes('tct') ? (
        <div style={{ width: '100%' }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
            containerProps={{ style: { height: '700px' } }}
          />
        </div>
      ) : (
        <></>
      )}
      {!resume && (
        <div style={{ width: '100%' }}>
          <DefaultTable
            dados={table}
            th2={'Menor quantidade de acertos'}
            th3={'Mediana da quantidade de acertos'}
            th4={'Média da quantidade de acertos'}
            th5={'Maior quantidade de acertos'}
            th6={'Desvio padrão'}
            th7={table5}
          />
        </div>
      )}
      {table && (
        <div>
          <Button>
            <CSVLink data={dadosCSV} filename={tituloCompleto}>
              Baixar gráfico em CSV
            </CSVLink>
          </Button>
        </div>
      )}
    </div>
  ) : (
    <div style={{ height: 'auto' }}>
      <InsufficientData />
    </div>
  );
};

export default styled(ComplexBarChart)`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #3e2;
  .div {
    color: #3e2;
  }
`;
